const errorMessageHelper = {
  nameFirst: {
    required: 'Il nome è obbligatorio',
    validate: 'Il nome non è valido',
  },
  nameLast: {
    required: 'Il cognome è obbligatorio',
    validate: 'Il cognome non è valido',
  },
  mobile: {
    required: 'è richiesto il numero di cellulare',
    validate: 'numero di cellulare non è valido',
  },
  email: {
      required: "è richiesta la mail"
  },
  privacy: {
    required: 'Devi controllare questa icona',
  },

};

export default errorMessageHelper;
